import { render, staticRenderFns } from "./SlideshowList.vue?vue&type=template&id=513e514c&scoped=true"
import script from "./SlideshowList.vue?vue&type=script&lang=js"
export * from "./SlideshowList.vue?vue&type=script&lang=js"
import style0 from "./SlideshowList.vue?vue&type=style&index=0&id=513e514c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e514c",
  null
  
)

export default component.exports